import {
  component_styles_default
} from "./chunk.GES5RFBK.js";
import {
  r
} from "./chunk.XVPEWHDV.js";

// src/components/icon/icon.styles.ts
var icon_styles_default = r`
  ${component_styles_default}

  :host {
    display: inline-block;
    width: 1em;
    height: 1em;
    contain: strict;
    box-sizing: content-box !important;
  }

  .icon,
  svg {
    display: block;
    height: 100%;
    width: 100%;
  }
`;

export {
  icon_styles_default
};
